// How many agents the workspace runs (subagents not counted), for the
// sidebar's workspace line and the phone's More screen. Until an agent list
// answers, the count this browser remembered for the workspace stands in
// (./navFlags), so "· 6 agents" is there on the first paint. Only a list
// that answered is remembered: a failed read is not "no agents".

import { useEffect } from "react";

import { useAgentDirectory } from "@/hooks/useAgentDirectory";
import { isBlueprint } from "@/lib/agentKind";

import { rememberAgentCount } from "./navFlags";
import { useRememberedNav } from "./useNavFlags";

/** null while nothing is known yet (no list answered and nothing remembered). */
export function useWorkspaceAgentCount(customerId: string | null | undefined): number | null {
  const { agents: all, answered } = useAgentDirectory(customerId);
  const live = answered ? all.filter((a) => !isBlueprint(a)).length : null;
  const remembered = useRememberedNav(customerId)?.agents;
  useEffect(() => {
    if (customerId && live !== null) rememberAgentCount(customerId, live);
  }, [customerId, live]);
  return live ?? remembered ?? null;
}
